import { useQuery } from "@tanstack/react-query";
import { trackTabAccess } from "./tabs.api";
import type { TabType } from "./tabs.type";
import { useAuth } from "../auth/useAuth";

export const tabAccessKeys = {
  all: ["tab-access"] as const,
  detail: (tabType: TabType, symbol: string) =>
    [...tabAccessKeys.all, tabType, symbol] as const,
};

// Note: the token returned here is intentionally NOT cached anywhere beyond
// this React Query entry. It is passed down as a prop to the hooks that need
// it (see e.g. useOverallRank), which gate on `!!tabAccessToken` so they only
// fire once a fresh token exists. Do not reintroduce a module-level/global
// store for this token - it would risk sending an expired token instead of
// triggering a fresh /tabs/:tab_type/:symbol call.
export const useTrackTabAccess = (tabType: TabType, symbol: string) => {
  const { user } = useAuth();

  return useQuery({
    queryKey: tabAccessKeys.detail(tabType, symbol),
    queryFn: () => trackTabAccess(tabType, symbol),
    enabled: !!symbol && !!tabType && !!user,
  });
};
